/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'sso-error',
  templateUrl: './sso-error.component.html',
  styleUrl: './sso-error.component.scss',
})
export class SsoErrorComponent implements OnInit {
  public ssoErrorMessage = '';
  private router = inject(ActivatedRoute);

  constructor(private readonly notificationsService: NotificationsService) {}

  public ngOnInit(): void {
    this.ssoErrorMessage = this.router.snapshot.queryParams.error;
    this.notificationsService.openSsoSnackbar({
      message: this.ssoErrorMessage,
      closeBtn: true,
    });
  }
}
